module.exports = __webpack_public_path__ + "img/collection-memoireRingsHalfSetMemories@2x.cdf0fa5.jpg";